import { devtools } from 'config/devtools'
import { create } from 'zustand'

import { UseRtmScenariosParams } from './types'

export const useRtmScenariosParams = create<UseRtmScenariosParams>()(
  devtools(
    (set) => ({
      filters: {},
      setFilters: (filters) => set({ filters }),
      clearFilters: () => set({ filters: {} }),
      search: '',
      setSearch: (search) => set({ search }),
      clearSearch: () => set({ search: '' }),
      ordering: null,
      setOrdering: (ordering) => set({ ordering }),
      clearOrdering: () => set({ ordering: null }),
    }),
    {
      store: 'rtmScenariosParams',
    },
  ),
)
